export const theme = {
  primary: '#627894',
  secondary: '#e45441',
  dark: '#2c3a51',
  light: '#ffffff',
  darken: '#03396c',
};

//old dark #2c3a51
